import { render, staticRenderFns } from "./VehicleView.vue?vue&type=template&id=65b0991c"
import script from "./VehicleView.vue?vue&type=script&lang=ts"
export * from "./VehicleView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports